import React, { useState, FC, useEffect } from "react"
import { styled } from '@mui/material'
import { TextField } from "@mui/material"

function countPeriods(stringExpression: string): number {
    let matches = 0
    
    for(let index = 0, stringLength = stringExpression.length; index < stringLength; index++) {
        if (stringExpression[index] === '.') {
            matches++
        }
    }

    return matches
}

function checkASCIIRanges(stringExpression: string): boolean {
    for(let index = 0, stringLength = stringExpression.length; index < stringLength; index++) {
        const charCode = stringExpression.charCodeAt(index)

        // Character is [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, '.']
        if (charCode >= 48 && charCode <= 57 || charCode === 46) {
            continue
        } else {
            return false
        }
    }

    return true
}

const StyledTextField = styled(TextField)(() => ({
    input: {
        paddingTop: '8.5px !important',
        paddingRight: '14px !important',
        paddingBottom: '8.5px !important',
        paddingLeft: '14px !important',
    },
}))

interface NumberFieldProps {
    value: string
    onChange: (value: string) => void
    integerOnly?: boolean
    disabled?: boolean
    error?: boolean
    min?: number
    startAdornment?: JSX.Element
}
export const NumberField: FC<NumberFieldProps> = ({
    value = '',
    onChange,
    integerOnly = false,
    disabled = false,
    error = false,
    min = 0,
    startAdornment,
}) => {
    const [tempValue, setTempValue] = useState(value)

    useEffect(() => {
        setTempValue(value)
    }, [value])

    return (
        <StyledTextField
            type="text"
            size="small"
            value={tempValue}
            onChange={(e) => {
                if (countPeriods(e.target.value) > (integerOnly ? 0 : 1)) {
                    return
                }
                if (!checkASCIIRanges(e.target.value)) {
                    return
                }

                setTempValue(e.target.value)
            }}
            onBlur={(e) => {
                if (isNaN(Number(e.target.value))) {
                    setTempValue('')
                    onChange('')
                    return
                }
                const value = Math.max(Number(e.target.value), 0)
                onChange(String(value))
            }}
            InputProps={{
                inputProps: {
                    min,
                },
                startAdornment,
                error,
            }}
            disabled={disabled}
        />
    )
}

export default NumberField
